import axios from 'axios'
// 正式
const baseURL = "https://curiousmore.com/qmore"
// 测试
// const baseURL = "http://139.186.169.185:8768/eg-api"
// const baseURL = "http://192.168.1.1:8768/eg-api"

// 本地
// const baseURL = 'http://192.168.1.111:8768/eg-api'


// axios.defaults.timeout = 5000
axios.defaults.baseURL = baseURL
// 携带cookies
axios.defaults.withCredentials = true;


axios.interceptors.request.use(function (config) {
    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
    axios.defaults.headers.token = localStorage.getItem("token")
    return config;
  }, function (error) {
    return Promise.reject(error);
  });




/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, data)
            .then(response => {
                resolve(response.data)
            }, err => {
                reject(err)
            })
    })
}
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        })
            .then(response => {
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.patch(url, data)
            .then(response => {
                resolve(response.data)
            }, err => {
                reject(err)
            })
    })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.put(url, data)
            .then(response => {
                resolve(response.data)
            }, err => {
                reject(err)
            })
    })
}


// WEBPACK FOOTER //
// ./src/request/http.js